import { InputAdornment } from '@mui/material';
import { NumberInput, NumberInputProps } from 'react-admin';
import { ReactElement } from 'react';
import { getCurrencySymbol } from './utils';

type Props = NumberInputProps & {
  adornment?: string;
  currency?: string;
};

export function CurrencyAmountInput({
  currency = 'AUD',
  adornment = getCurrencySymbol(currency),
  step = 0.01,
  slotProps,
  ...rest
}: Props): ReactElement {
  const startAdornment = <InputAdornment position="start">{adornment}</InputAdornment>;

  return (
    <NumberInput
      step={step}
      {...rest}
      slotProps={{
        ...slotProps,
        input: {
          ...(slotProps?.input ?? {}),
          startAdornment,
        },
      }}
    />
  );
}
